import { Directive, ElementRef } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

@Directive({
    selector: '[appFormValidation]',
    standalone: false,
})
export class FormValidationDirective {
    submit$ = fromEvent(this.element, 'submit')
        .pipe(
            tap(() => {
                if (this.element.classList.contains('submitted') === false) {
                    this.element.classList.add('submitted');
                }
            }),
            shareReplay(1)
        )
        .subscribe();

    constructor(private host: ElementRef<HTMLFormElement>) {}

    get element() {
        return this.host.nativeElement;
    }
}
